export const CONFIRM_TEXT = {
    MOVE_TO_LIST: "저장되지 않은 변경 사항이 있습니다. 그래도 이동하시겠습니까?",
    DELETE: "삭제하시겠습니까?",
    DELETE_SUCCESS: "삭제되었습니다.",
    DELETE_FAIL: "삭제에 실패했습니다.",
};
